import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { ClassroomInviteInfo } from 'frontend/types/classrooms';

interface JoinClassroomFromCodeState {
  classroom_invite_info?: ClassroomInviteInfo;
}

const joinClassroomFromCode: Module<JoinClassroomFromCodeState, RootState> = {
  namespaced: true,
  state: {
    classroom_invite_info: undefined,
  },
  mutations: {
    setValue(state: JoinClassroomFromCodeState, value: JoinClassroomFromCodeState) {
      state.classroom_invite_info = value.classroom_invite_info;
    },
  },
  actions: {},
  getters: {
    classroomInviteInfo: (state: JoinClassroomFromCodeState): ClassroomInviteInfo | undefined =>
      state.classroom_invite_info,
  },
};

export default joinClassroomFromCode;
